import React, { ReactElement } from 'react';
import TextBlock from '../text-block/text-block.component';
import useStylesRequiredMark from './required-mark.styles';

const RequiredMark: ReactMemoComponent = React.memo((): ReactElement => {
  const { classes } = useStylesRequiredMark();

  return (
    <TextBlock>
      {' '}
      <TextBlock className={classes.requiredMark}>
        *
      </TextBlock>
    </TextBlock>
  );
});

export default RequiredMark;
